<template>
  <div>
    <navbar
      position="fixed"
      menu-classes="ml-auto d-md-flex justify-contente-md-between"
      class="menu-navbar w-100 d-flex"
    >
      <template slot-scope="{ toggle, isToggled }">
        <nav-link class="navbar-brand" :to="'/'">
          <img style="max-height: 90px; max-width: 200px;" :src="linkLogo" />
        </nav-link>
      </template>

      <template slot="navbar-menu">
        <li class="nav-item">
          <nav-link class="nav-link linkMenu" :to="'/'">
            <p>HOME</p>
          </nav-link>
        </li>
        <li class="nav-item">
          <nav-link class="nav-link linkMenu" :to="'/QuemSomos'">
            <p>Quem Somos</p>
          </nav-link>
        </li>
        <li class="nav-item">
          <nav-link class="nav-link linkMenu" :to="'/Ajuda'">
            <p>FAQ</p>
          </nav-link>
        </li>
        <!--li class="nav-item" v-if="!decoded">
          <a
            href="javascript:void(0)"
            class="nav-link linkMenu"
            @click="modalCadastrese = true"
          >
            <p>CADASTRE-SE</p>
          </a>
        </li>
        <li class="nav-item item-saldo" v-if="decoded">
          <a
            href="javascript:void(0)"
            class="nav-link linkMenu"
            @click="modalSaldo = true"
          >
            <i class="fa-duotone fa-coins"></i>
            <span>{{ saldo | currency }}</span>
          </a>
        </li>
        <li class="nav-item" v-if="!decoded">
          <button
            class="nav-link  nav-link-destaque btn-degrade btn-block text-left"
            @click="modalLogin = true"
          >
            <p>ENTRAR</p>
          </button>
        </li>
        <drop-down--
          v-else
          tag="li"
          icon="fa fa-user"
          class="linkDropMenu"
          :title="decoded.nome"
        >
          <nav-link class="dropdown-item linkMenu" to="dashBoard"
            ><i class="now-ui-icons users_single-02 mr-3"></i>Dados
            Cadastrais</nav-link
          >

          <nav-link class="dropdown-item linkMenu" to="/saldoInterno"
            ><i class="now-ui-icons business_money-coins mr-3"></i>Adicionar
            Créditos</nav-link
          >

          <nav-link class="dropdown-item linkMenu" to="/meuEndereco"
            ><i class="now-ui-icons location_pin mr-3"></i>Endereço</nav-link
          >

          <nav-link class="dropdown-item linkMenu" to="/Afiliados"
            ><i class="now-ui-icons users_single-02 mr-3"></i
            >Afiliados</nav-link
          >

          <nav-link class="dropdown-item linkMenu" to="/meuFinanceiro"
            ><i class="now-ui-icons business_money-coins mr-3"></i>Meu
            Financeiro
          </nav-link>

          <nav-link class="dropdown-item linkMenu" to="/meusItens"
            ><i class="now-ui-icons design_app mr-3"></i>Meus Itens</nav-link
          >

          <nav-link class="dropdown-item linkMenu" to="/MinhasEntregas"
            ><i class="now-ui-icons shopping_delivery-fast mr-3"></i>Minhas
            Entregas</nav-link
          >

          <nav-link class="dropdown-item linkMenu" to="/MeuHistorico"
            ><i class="now-ui-icons design_bullet-list-67 mr-3"></i
            >Históricos</nav-link
          >

          <nav-link class="dropdown-item linkMenu" to="/logoff"
            ><i class="now-ui-icons media-1_button-power mr-3"></i
            >Sair</nav-link
          >
        </drop-down-->
        <li class="nav-item">
          <form class="form-navbar" method="get" action="/">
            <div class="form-group">
              <div class="input-group w-full">
                <div class="input-group-prepend">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </div>
                <input
                  aria-describedby="addon-right addon-left"
                  placeholder="Pesquisar..."
                  v-model="palavraChave"
                  name="palavra"
                  class="form-control"
                />
              </div>
            </div>
          </form>
        </li>
      </template>
    </navbar>
  </div>
</template>

<script>
import {
  DropDown,
  NavbarToggleButton,
  Navbar,
  NavLink,
  Modal,
  Button,
  Card,
  Badge,
} from '@/components';
import { Popover } from 'element-ui';
import jwt from 'jsonwebtoken';
import storage from './../services/storage';
import service from './../services';
import { KEY_LOCAL_STORAGE } from './../const';

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    [Button.name]: Button,
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
    Modal,
    Card,
    Badge,
  },
  data() {
    return {
      linkLogo:
        'https://novositecbc.s3.us-east-2.amazonaws.com/assets/logo-clube-certo.webp',
      modalLogin: false,
      modalCadastrese: false,
      modalSaldo: false,
      decoded: null,
      saldo: 0,
      myInterval: null,
      subscribed: null,
      palavraChave: this.getPalavra(),
    };
  },
  methods: {
    getPalavra() {
      return this.$route.query ? this.$route.query.palavra : null;
    },
    retornaLinkLogo() {
      const logo = storage.lerStorage('logo');
      return logo;
    },
    retornaLinkLoja() {
      const linkLoja = storage.lerStorage('linkLoja');
      return linkLoja;
    },
    retornaQtd() {
      const qtd = storage.lerStorage('qtd-itens');
      if (qtd) {
        return qtd;
      } else return 0;
    },
    buscarDados() {
      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);

      if (token) {
        this.decoded = jwt.decode(token);
      } else {
        this.decoded = null;
      }

      let saldo = storage.lerStorage(KEY_LOCAL_STORAGE.SALDO);
      if (saldo) {
        this.saldo = window.atob(saldo);
      }
    },
    buscarDadosBanco() {
      if (this.decoded) {
        service
          .getAll('Usuario', {}, 'BuscarSaldo')
          .then(res => {
            const s = storage.lerStorage(KEY_LOCAL_STORAGE.SALDO);
            storage.escreveStorage(KEY_LOCAL_STORAGE.SALDO, res.data.s);
            if (s != res.data.s) {
              // this.playCoins();
            }

            this.retornaQtd();
          })
          .catch(e => {
            console.error(e);
            storage.removeItem(KEY_LOCAL_STORAGE.USER_TOKEN);
          });
      }
    },
    verificaUid() {
      if (this.$route.query.uid) {
        storage.escreveStorage('uid', this.$route.query.uid);
      }
    },

    changeLocalStorage() {
      const logo = this.retornaLinkLogo();
      if (logo) {
        this.linkLogo = logo;
      }
      this.$forceUpdate();
    },
    fechaModais() {
      this.modalLogin = false;
      this.modalCadastrese = false;
      this.modalSaldo = false;
    },
    finalizaBoxLogin(from) {
      this.fechaModais();
      if (from == 'Cadastro') this.modalSaldo = true;
      if (from == 'voltar') this.modalLogin = true;
    },
  },
  created() {
    this.verificaUid();
    this.subscribed = storage.subscribe(this.changeLocalStorage);
  },

  mounted() {
    this.buscarDados();
    //this.buscarDadosBanco();
  },
  beforeDestroy() {
    storage.unsubscribe(this.subscribed);
    clearInterval(this.myInterval);
  },
};
</script>

<style lang="scss">
.modal-open {
  overflow: auto !important;
}

.linkModalBemVindo {
  text-align: center !important;
  width: 100% !important;
  color: #fff !important;
}
.linkModalBemVindo:hover {
  background-color: transparent !important;
}

nav .dropdown-menu .dropdown-item.active,
nav .dropdown-menu .dropdown-item:active {
  color: inherit !important;
}

nav.navbar-transparent .router-link-active {
  /*color: #fff !important;*/
}
nav.navbar-transparent .dropdown-menu .router-link-active {
  color: #212529 !important;
}

.nav-open .dropdown-item.active,
.nav-open .dropdown-item:active {
  /*background-color: #ffb236 !important;*/
}

.navbar .router-link-active {
  background-color: transparent !important;
}
/*
.menu-navbar {
  background-color: #030303 !important;
}
*/
.item-saldo {
  a {
    display: flex;
  }
  i {
    display: flex;
    font-size: 16px;
    margin: 5px 5px 0 0;
  }
  span {
    display: flex;
  }
}

.linkDropMenu i {
  margin-right: 5px;
}

.dropdown.show .dropdown-menu,
.dropdown-menu.open {
  width: 200px;
}
</style>

<style lang="scss" scoped>
.form-navbar {
  .input-group-prepend {
    background-color: white;
    border-radius: 10px 0 0 10px;
    border: 1px solid #e3e3e3;
    height: 44px;
    padding: 10px;
    border-radius: 0.25rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
    margin: 0.035em 0;

    color: black;
    i {
      margin-top: 5px;
    }
  }
  .input-group {
    .form-control:focus {
      border: 1px solid #e3e3e3 !important;
      border-left: 0 none;
    }
  }
}
</style>
